<scope-details
  [isUpdateLoading]="isUpdateLoading$ | async"
  [currentScope]="currentScope$ | async"
  [officeLocations]="scopeDetailsService.officeLocations$ | async"
  [secondParties]="scopeDetailsService.secondParties$ | async"
  [selectedSecondParty]="scopeDetailsService.secondParty$ | async"
  [selectedOfficeLocation]="scopeDetailsService.officeLocation$ | async"
  [customFieldsDefinitionOutdated]="scopeDetailsService.customFieldsOutdated$ | async"
  [sowRetainedTeamStats]="sowRetainedTeamStats$ | async"
  [benchmarkRateCards]="scopeDetailsService.benchmarkRateCardOptions$ | async"
  [xlsxTemplates]="scopeDetailsService.xlsxTemplates$ | async"
  (onGetSecondParty)="scopeDetailsService.getSecondParty($event)"
  (onGetOfficeLocation)="scopeDetailsService.getOfficeLocation($event)"
  (onConfirmMetaStructureUpdate)="confirmMetaStructureUpdate($event)"
  (onSaveScope)="saveDetails($event)">
</scope-details>
